export default __webpack_public_path__ + "static/media/arrow-forward.b309adc2.svg";